import { Nullable } from '@ps/utils';
import { CompanyType } from './company.model';

export type SupplierType = 'private' | 'public';

export interface SupplierSettingsForm {
  supplierType: SupplierType;
  dynamicProfiler: boolean;
  isSegmentationEnabled: boolean;
  isPrivacyPolicyActive: boolean;
  cookieYesIntegration: boolean;
  hemsOnPixels: boolean;
  isDataQualityQuestionsActive: boolean;
  isAsrRedirectionEnable: boolean;
  skipPreScreener: boolean;
  isScreenerV2: boolean;
  isHashing: boolean;
  isHashingInbound: boolean;
  privateKey: string;
  isNotify: boolean;
  iss2sCallback: boolean;
  isCompleteToNonCompleteURL: string;
  isNonCompleteToCompleteURL: string;
  s2sMicroRewardCallbackURL: string;
  suppUrlCompletes: string;
  suppUrlOverquota: string;
  suppUrlTerms: string;
  suppUrlSecurityTerms: string;
  microSurveySetting: MicroSurveySettingsForm;
  variableMapping: SupplierVariableMappingForm;
}

export interface MicroSurveySettingsForm {
  active: boolean;
  showConsent: boolean;
  showMicrosurveySettings: boolean;
  currencyName: string;
  conversionValue: Nullable<number>;
  rewardAmount: Nullable<number>;
}

export interface VariableMappingFieldForm {
  incoming: string;
  outgoing: string;
}

export interface SupplierVariableMappingForm {
  psSupplierSid: VariableMappingFieldForm;
  psSupplierRespondentId: VariableMappingFieldForm;
  psCustomSvar1: VariableMappingFieldForm;
  psCustomSvar2: VariableMappingFieldForm;
  psTermRsn: VariableMappingFieldForm;
  psPsid: VariableMappingFieldForm;
  psRstatus: VariableMappingFieldForm;
  psHash: VariableMappingFieldForm;
  psOqid: VariableMappingFieldForm;
  psCpi: VariableMappingFieldForm;
  psSurveyid: VariableMappingFieldForm;
}

export interface CompanyDetailFormModel {
  name: string;
  address: string;
  phone: string;
  primaryLiaison: string;
  secondaryLiaison: string;
  fx: Nullable<number>;
  companyType: Nullable<CompanyType>;
  isAServiceAccount: boolean;
  isTestAccount: boolean;
  tempGenerateInvoice: string;
  accountManagerIds: number[];
  projectManagerId: Nullable<number>;
  orgId: string;
  suppUrlCompletes: string;
  suppUrlOverquota: string;
  suppUrlTerms: string;
  suppUrlSecurityTerms: string;
  isNotify: boolean;
  isExpose: boolean;
  isAdditionalMetrics: boolean;
  isPureScoreEnable: boolean;
  isRdFlagsEnable: boolean;
  appendProfileOnRedirects: boolean;
  isIncludeBuyerInfoOnStatementReport: boolean;
  isManualSupplier: boolean;
  showTrafficChannel: boolean;
  netsuiteEnabled: boolean;
  netsuiteInternalId: string;
  netsuiteCompanyName: string;
  netsuitePrimaryEmail: string;
  netsuiteBillingAddress: string;
  netsuiteBillingCity: string;
  netsuiteBillingState: string;
  netsuiteBillingZip: string;
  netsuiteBillingCountry: string;
}

export const INVOICE_TYPES = [
  { value: 'MONTHLY', label: 'Monthly' },
  { value: 'PROJECT', label: 'Project' },
  { value: 'PO', label: 'PO' },
] as const;

export const DEFAULT_INVOICE_TYPE = 'MONTHLY';

export const SUPPLIER_CURRENCY_FX = 321;

export const EMPTY_COMPANY_FORM_MODEL: CompanyDetailFormModel = {
  name: '',
  address: '',
  phone: '',
  primaryLiaison: '',
  secondaryLiaison: '',
  fx: null,
  companyType: null,
  isAServiceAccount: false,
  isTestAccount: false,
  tempGenerateInvoice: DEFAULT_INVOICE_TYPE,
  accountManagerIds: [],
  projectManagerId: null,
  orgId: '',
  suppUrlCompletes: '',
  suppUrlOverquota: '',
  suppUrlTerms: '',
  suppUrlSecurityTerms: '',
  isNotify: false,
  isExpose: false,
  isAdditionalMetrics: false,
  isPureScoreEnable: false,
  isRdFlagsEnable: false,
  appendProfileOnRedirects: false,
  isIncludeBuyerInfoOnStatementReport: false,
  isManualSupplier: false,
  showTrafficChannel: false,
  netsuiteEnabled: false,
  netsuiteInternalId: '',
  netsuiteCompanyName: '',
  netsuitePrimaryEmail: '',
  netsuiteBillingAddress: '',
  netsuiteBillingCity: '',
  netsuiteBillingState: '',
  netsuiteBillingZip: '',
  netsuiteBillingCountry: '',
};
